"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LimitQueue = /*#__PURE__*/function () {
  function LimitQueue() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, LimitQueue);

    this.limit = limit;
    this.items = [];
    this.currentIndex = 0;
  }

  _createClass(LimitQueue, [{
    key: "push",
    value: function push(item) {
      var hasCapacity = this.currentIndex < this.limit;
      this.currentIndex = hasCapacity ? this.currentIndex + 1 : 0;
      this.items.splice(this.currentIndex, 1, item);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return this.items;
    }
  }]);

  return LimitQueue;
}();

var createSentryRequestIdQueue = function createSentryRequestIdQueue(limit) {
  return new LimitQueue(limit || 10);
};

var getSentryRequestIdQueue = function getSentryRequestIdQueue(limit) {
  return createSentryRequestIdQueue(limit);
};

var pushRequestIdToSentry = function pushRequestIdToSentry(sentryEnabled, limit) {
  return function (requestId) {
    if (sentryEnabled && requestId) {
      // Из-за дублирования заголовка x-request-id в качестве requestId
      // может прийти строка из нескольких идентификаторов разделённых ','
      // В Sentry отправляем только уникальные requestId
      var requestIdArray = requestId.split(',').map(function (item) {
        return item.trim();
      });

      var uniqueRequestId = _toConsumableArray(new Set(requestIdArray)).join(', ');

      var sentryRequestQueue = getSentryRequestIdQueue(limit);
      sentryRequestQueue.push(uniqueRequestId);
      Sentry.configureScope(function (scope) {
        scope.setExtra('lastAsyncRequestIds', sentryRequestQueue.getItems());
      });
    }
  };
};

var _default = pushRequestIdToSentry;
exports.default = _default;